export default "__VITE_ASSET__Vi$F9$1F__"